// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\">\tSite Map\t</h1> <h2 id=\"manage-your-loans\"><a href=\"/manage\">Manage Your Loans</a></h2> ";
// Exports
export default code;